// extracted by mini-css-extract-plugin
export var borderbottom = "ParagraphMediaContentList-module--borderbottom--8909e";
export var bordertop = "ParagraphMediaContentList-module--bordertop--18a1a";
export var paragraphmediacontentlistinner = "ParagraphMediaContentList-module--paragraphmediacontentlistinner--93999";
export var paragraphmediacontentlistouter = "ParagraphMediaContentList-module--paragraphmediacontentlistouter--5ec27";